var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1708 11.9969L15.9262 16.292L0.13208 0.533691L13.1017 3.9619L19.1708 11.9969Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3366 20.1616L22.1799 22.5342L17.8179 18.182L20.8271 14.1919L25.3366 20.1616Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6727 23.2538L25.4312 25.4858L25.3256 25.5912C25.2992 25.6175 25.286 25.6307 25.286 25.6307L24.074 24.4214L25.8536 23.0848L26.9336 22.2749L27.6155 23.1769L27.6727 23.2538Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9262 16.2921L12.807 20.4226L10.0639 18.3595L8.69345 17.3302L3.56587 13.4762L0.13208 0.533691L15.9262 16.2921Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.18 22.5338L18.9002 25.0008L14.9253 22.0137L17.8179 18.1816L22.18 22.5338Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.286 25.6309C25.286 25.6309 25.2002 25.7165 25.0484 25.868L22.9036 28.0101L22.8266 27.953L21.0999 26.6537L22.6683 25.4773L24.0739 24.4194L25.286 25.6287V25.6309Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4351 37.7522L26.927 27.2678L28.6472 25.5515C28.6472 25.5515 29.3511 26.7981 34.1949 29.0587C39.0387 31.3193 42.0854 33.0334 38.2974 36.8918L37.4373 37.75L26.9292 27.2656L28.6494 25.5493L37.4373 37.75L37.4351 37.7522Z",
    fill: "#683B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4351 37.7519L26.927 27.2676L25.2068 28.9839C25.2068 28.9839 26.4562 29.6862 28.722 34.5191C30.9877 39.3519 32.7057 42.3916 36.5728 38.6123L37.4329 37.7541L26.9248 27.2698L25.2046 28.9861L37.4329 37.7541L37.4351 37.7519Z",
    fill: "#87501A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8048 28.1461L26.0956 28.0978L22.9038 28.0122L22.8928 27.8981L22.6685 25.4794L24.0741 24.4216L25.8537 23.085L27.5563 23.243L27.6729 23.254L27.7586 26.4385L27.8048 28.1461Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9725 23.8597C35.9725 23.8597 33.2008 24.641 30.4401 27.0421C30.2949 27.1672 30.1475 27.3011 30.0024 27.4349C29.624 27.7883 29.2457 28.1724 28.8827 28.5916L28.5681 28.9054L27.8048 28.1439L25.2861 25.6309C25.2861 25.6309 25.2993 25.6177 25.3257 25.5913C25.5215 25.3938 26.4256 24.4808 27.5563 23.243C27.5739 23.2232 27.5937 23.1991 27.6157 23.1771C28.6473 22.049 29.8594 20.6531 30.8867 19.3012V19.2946L30.8933 19.2924H30.8977C30.9681 19.1958 31.0406 19.1015 31.1088 19.0049L31.1814 19.0773L35.9703 23.8597H35.9725Z",
    fill: "#9E2020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5681 28.9052L28.2536 29.219C27.8334 29.5834 27.4485 29.9609 27.0943 30.3362C26.9579 30.481 26.8259 30.6281 26.7006 30.7729C24.294 33.5274 23.5131 36.2927 23.5131 36.2927L20.9417 33.7271L23.3834 31.2909L22.1471 30.3779C21.7951 30.1189 21.4278 29.8358 21.0428 29.5285C21.6764 28.9886 22.2835 28.4509 22.829 27.9571C22.8532 27.9329 22.8752 27.9132 22.895 27.8978C23.8893 26.9958 24.6724 26.2342 25.0486 25.8698C25.2003 25.7184 25.2861 25.6328 25.2861 25.6328L27.8048 28.1458L28.5681 28.9074V28.9052Z",
    fill: "#D63C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1086 19.0049C31.0382 19.1015 30.9657 19.1958 30.8975 19.2924L31.1834 19.0773L31.1108 19.0049H31.1086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8681 0.533691L26.8962 3.95971L12.3274 23.2538L14.7119 25.6329L39.8681 0.533691Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8681 0.533691L36.4343 13.4762L17.0964 28.012L14.7119 25.6329L39.8681 0.533691Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56492 37.7522L13.0731 27.2678L11.3529 25.5515C11.3529 25.5515 10.6489 26.7981 5.80513 29.0587C0.961308 31.3193 -2.08533 33.0334 1.70262 36.8918L2.56272 37.75L13.0709 27.2656L11.3507 25.5493",
    fill: "#683B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.56494 37.7519L13.0731 27.2676L14.7933 28.9839C14.7933 28.9839 13.5438 29.6862 11.2781 34.5191C9.01237 39.3519 7.29437 42.3916 3.42724 38.6123L2.56714 37.7541L13.0753 27.2698L14.7955 28.9861",
    fill: "#87501A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3273 23.2536L17.5825 22.7686L17.0963 28.0118L12.1931 28.1457L12.3273 23.2536Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.712 25.6328C14.712 25.6328 11.2342 22.1629 8.88925 19.0068L4.02563 23.8594C4.02563 23.8594 7.95216 24.97 11.1154 28.5957L11.4299 28.9096L14.712 25.635V25.6328Z",
    fill: "#9E2020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7119 25.6328C14.7119 25.6328 18.1897 29.1027 21.3529 31.4423L16.4893 36.2949C16.4893 36.2949 15.3763 32.3773 11.7423 29.2212L11.4277 28.9074L14.7097 25.6328H14.7119Z",
    fill: "#D63C3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.533691)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction);
export default __webpack_public_path__ + "static/media/action.85e279c24516fc7db8a061f94c4857d1.svg";
export { ForwardRef as ReactComponent };